import { render } from "./Carrocel.vue?vue&type=template&id=e2efc3d2&scoped=true"
import script from "./Carrocel.vue?vue&type=script&lang=js"
export * from "./Carrocel.vue?vue&type=script&lang=js"

import "./Carrocel.vue?vue&type=style&index=0&id=e2efc3d2&lang=scss"
import "./Carrocel.vue?vue&type=style&index=1&id=e2efc3d2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2efc3d2"]])

export default __exports__